import React, { useState } from 'react';
import {
  Button,
  SaveButton,
  useCreate,
  useNotify,
} from 'react-admin';

import IconEmail from '@material-ui/icons/Email';
import IconCancel from '@material-ui/icons/Cancel';
import IconSend from '@material-ui/icons/Send';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { User } from 'resources/types';

interface Props {
  record: User;
}

const resource = 'resend-onboarding';

export const ResendOnboardingEmailButton = ({ record }: Props) => {


  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate(resource);
  const notify = useNotify();

  const handleClick = () => setShowDialog(true);
  const handleCloseClick = () => setShowDialog(false);

  const handleSubmit = async () => {
    create(
      { payload: { data: { id: record?.id } } },
      {
        onSuccess: () => {
          setShowDialog(false);
          notify('Onboarding email sent successfully', 'success');
        },
        onFailure: (error: Error) => notify(error.message, 'error'),
      }
    );
  };

    // Only show button if account has access to new platform
  if (!record?.account?.hasAccessNewPlatform) {
    return null;
  }

  return (
    <>
      <Button onClick={handleClick} label="Resend Onboarding Email">
        <IconEmail />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Resend Onboarding Email"
      >
        <DialogTitle>Resend Onboarding Email</DialogTitle>
        <DialogContent>
          <div>
            An onboarding email will be sent to the user's current email address.
          </div>
        </DialogContent>
        <DialogActions>
          <SaveButton
            label="Send"
            icon={<IconSend />}
            handleSubmitWithRedirect={handleSubmit}
            disabled={loading}
          />
          <Button
            label="ra.action.cancel"
            onClick={handleCloseClick}
            disabled={loading}
          >
            <IconCancel />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

